import React from 'react';
import { IllustrationRounded } from '../../../../../../design-system/src';
import Art from '../../../../../../sales-conversation/src/assets/Art';
import Bicycle from '../../../../../../sales-conversation/src/assets/Bicycle';
import Computer from '../../../../../../sales-conversation/src/assets/Computer';
import Drone from '../../../../../../sales-conversation/src/assets/Drone';
import Garden from '../../../../../../sales-conversation/src/assets/Garden';
import Jewelry from '../../../../../../sales-conversation/src/assets/Jewelry';
import PersonalTransporter from '../../../../../../sales-conversation/src/assets/PersonalTransporter';
import Pet from '../../../../../../sales-conversation/src/assets/Pet';

interface Props {
  type: string;
}

const InterestsIconSelector: React.FC<React.PropsWithChildren<Props>> = ({
  type,
}) => {
  switch (type?.toLowerCase()) {
    case 'informatics':
      return <Computer />;
    case 'art':
      return <Art />;
    case 'cycling':
      return <Bicycle />;
    case 'drones':
      return <Drone />;
    case 'garden':
      return <Garden />;
    case 'jewels':
      return <Jewelry />;
    case 'personal_transporters':
      return <PersonalTransporter />;
    case 'pets':
      return <Pet />;
    default:
      return <IllustrationRounded type={type} />;
  }
};

export default InterestsIconSelector;
